import { useQuery } from "@tanstack/react-query";
import axios from "../../api/axiosInstance";

export const useVehiculoUbicacionActual = (vehid, manid, enabled = true) => {
  return useQuery({
    queryKey: ["vehiculo-ubicacion", vehid, manid],
    queryFn: async () => {
      const { data } = await axios.get(`/vehicles/tracking/${vehid}`, {
        params: { manid },
      });
      return data;
    },
    enabled: !!vehid && !!manid && enabled,
    staleTime: 5000, // cache corto
    refetchInterval: 15000, // actualiza cada 15s
    retry: 0,
  });
};